"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceCards = void 0;
const gsap_1 = require("gsap");
const ScrollTrigger_1 = require("gsap/ScrollTrigger");
//@ts-expect-error import gsap timeline from core
var Timeline = gsap_1.gsap.core.Timeline;
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
class ServiceCards {
    static init() {
        gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger, Timeline);
        const panels = document.querySelectorAll('section.services .service-panel');
        if (!panels) {
            return;
        }
        const tl = gsap_1.gsap.timeline({
            scrollTrigger: {
                trigger: 'section.services',
                start: '-100px top',
                end: () => `+=${(panels.length + 1) * 100}%`,
                scrub: true,
                pin: true,
            },
        });
        panels.forEach((panel, index) => {
            const circle = document.querySelector(`.indicators .progress-${index} .progress`);
            if (index > 0) {
                tl.fromTo(panel, { top: '80vh' }, { top: 0, ease: 'none' });
            }
            tl.fromTo(circle, { strokeDashoffset: 82 }, {
                strokeDashoffset: 0,
                ease: 'power4.out',
            });
            if (index + 1 !== panels.length) {
                tl.fromTo(panel, { transform: 'scale(1)' }, { transform: 'scale(0.95)', ease: 'none' });
            }
        });
    }
}
exports.ServiceCards = ServiceCards;
